import { createTheme } from '@mui/material/styles';

const DupontWaterTheme = createTheme({
  palette: {
    primary: {
      main: '#128370',
      contrastText: 'rgba(255, 255, 255, 0.65)',
    },
    secondary: {
      main: '#223344',
    },
  },
  typography: {
    button: {
      fontFamily: 'Diodrum',
      //fontSize: '1rem',
      fontWeight: '100',
      letterSpacing: '0',
      lineHeight: 1.25,
    },
  },
  components: {
    MuiTouchRipple: {
      styleOverrides: {
        ripple: {
          display: 'none', // Disable the ripple effect
        },
      },
    },
  },
});

export default DupontWaterTheme;
